import {
  chartLocalStateKey,
  clearChartLocalState,
  clearChartLocalStateForWorkspaceTab,
} from 'features/timeSeries/utils/chartLocalState'

/**
 * Drops the chart drafts a tab leaves behind. Tab ids never recur, so anything
 * left would accumulate forever.
 */
export function clearWorkspaceTabChartState(
  siteId: string,
  tabId: string
): void {
  clearChartLocalState(chartLocalStateKey(siteId, tabId))
  clearChartLocalStateForWorkspaceTab(tabId)
}
